/* eslint-disable react/jsx-pascal-case */
import { memo, useEffect, useRef } from 'react'
import TableCell from '@material-ui/core/TableCell'
import Checkbox from '@material-ui/core/Checkbox'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { baseStyle } from 'assets/TableHeader'

type Props = {
  isChecked: boolean
  click?: React.MouseEventHandler<HTMLSpanElement> | undefined
  refs?: React.RefObject<HTMLTableCellElement>[]
  refIndex?: number
  disabled?: boolean
  focus?: boolean
  left?: number
  color?: string
}

const useStyles = makeStyles(() =>
  createStyles({
    hidden: {
      backgroundColor: 'inherit',
    },
    fixed: (props: { left?: number }) => ({
      position: 'sticky',
      backgroundColor: 'inherit',
      left: props.left,
      zIndex: 1,
    }),
  }),
)

/**
 * 幅をpx指定する場合はこちら
 * @param param0
 * @returns
 */
const A_TableCellText = ({ click = () => {}, isChecked, refs, refIndex = 0, disabled = false, focus = false, left = undefined, color = 'none' }: Props) => {
  useEffect(() => {
    if (focus) {
      ref.current?.focus()
    }
  }, [focus])

  const classes = useStyles({ left: left })
  const ref = useRef<HTMLInputElement>(null)

  const style = { ...baseStyle, minWidth: 35, backgroundColor: color }
  const leftClass = left != null ? classes.fixed : undefined

  return (
    <TableCell style={style} className={leftClass} onClick={click} padding="checkbox" align="center" ref={refs ? refs[refIndex] : undefined}>
      <Checkbox checked={isChecked} onClick={click} disabled={disabled} />
    </TableCell>
  )
}

export default memo(A_TableCellText)
